import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import * as constants from "../constants"
import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePermision extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  emloyee_permision_id: "",
                  selectedEmployee: "",
                  optionEmployee: [],
                  selectedEntity: "",
                  optionEntity: [],
                  selectedMode: "",
                  optionMode: [],
                  car_image: "",
                  orderBy: "emloyee_permision_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPermision: true,

                  selectedFilterEmployee: { value: 0, label: "همه کارمندان " },
                  optionFilterEmployee: [{ value: 0, label: "همه کارمندان " }],
                  selectedFilterEntity: { value: 0, label: "همه مدیریت ها " },
                  optionFilterEntity: [{ value: 0, label: "همه مدیریت ها " }],
                  selectedFilterMode: { value: 0, label: "همه عملیات ها" },
                  optionFilterMode: [{ value: 0, label: "همه عملیات ها" }],
            }
      }

      handleFilterEmployee = (selectedFilterEmployee) => {
            this.setState({ selectedFilterEmployee: selectedFilterEmployee }, () => {
                  this.filterFieldCompany()
            })
      }

      handleFilterEntity = (selectedFilterEntity) => {
            this.setState({ selectedFilterEntity: selectedFilterEntity }, () => {
                  this.filterFieldCompany()
            })
      }
      handleFilterMode = (selectedFilterMode) => {
            this.setState({ selectedFilterMode: selectedFilterMode }, () => {
                  this.filterFieldCompany()
            })
      }

      handleEmployee = (selectedEmployee) => {
            this.setState({ selectedEmployee: selectedEmployee }, () => {})
      }

      handleEntity = (selectedEntity) => {
            this.setState({ selectedEntity: selectedEntity }, () => {})
      }
      handleMode = (selectedMode) => {
            this.setState({ selectedMode: selectedMode }, () => {})
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ car_deactive: "0" })
            } else {
                  this.setState({ car_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        emloyee_permision_id: row2.emloyee_permision_id,

                        selectedEmployee: { value: row2.emloyee_permision_emloyee_id, label: row2.employee_name },
                        selectedEntity: { value: row2.emloyee_permision_entity, label: row2.permision_entity_desc },
                        selectedMode: { value: row2.emloyee_permision_mode, label: row2.permision_mode_desc },

                        newPermision: false,
                  },
                  () => {}
            )
      }

      newPermision = (event) => {
            this.setState({
                  emloyee_permision_id: "",
                  newPermision: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getPermision()
                                    self.getoptionEmployee()
                                    self.getoptionEntity()
                                    self.getoptionMode()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionEmployee = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه کارمندان " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].employee_id,
                                          label: arr.data[k].employee_name + " " + arr.data[k].employee_family,
                                    })
                                    Company1.push({
                                          value: arr.data[k].employee_id,
                                          label: arr.data[k].employee_name + " " + arr.data[k].employee_family,
                                    })
                              }
                              self.setState(
                                    { optionEmployee: Company, optionFilterEmployee: Company1, selectedFilterEmployee: Company1[0] },
                                    () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionEntity = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه مدیریت ها " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].permision_entity_name, label: arr.data[k].permision_entity_desc })
                                    Company1.push({ value: arr.data[k].permision_entity_name, label: arr.data[k].permision_entity_desc })
                              }
                              self.setState({ optionEntity: Company, optionFilterEntity: Company1, selectedFilterEntity: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_permission_entity")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه انواع گروه ها " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].permision_mode_name, label: arr.data[k].permision_mode_desc })
                                    Company1.push({ value: arr.data[k].permision_mode_name, label: arr.data[k].permision_mode_desc })
                              }
                              self.setState({ optionMode: Company, optionFilterMode: Company1, selectedFilterMode: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_permission_mode")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPermision() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee_permission")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewPermision = (imageCode) => {
            const { emloyee_permision_id, selectedEmployee, selectedEntity, selectedMode } = this.state
            if (selectedEmployee != "" && selectedEntity != "" && selectedMode != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPermision()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_employee_permission")
                  fd.append("emloyee_permision_emloyee_id", selectedEmployee.value)
                  fd.append("emloyee_permision_entity", selectedEntity.value)
                  fd.append("emloyee_permision_mode", selectedMode.value)

                  xhttp.open("POST", `${constants.BASE_URL}/employee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات  دسترسی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      deletePermision = (imageCode) => {
            const { emloyee_permision_id } = this.state

            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPermision()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_employee_permission")
            fd.append("emloyee_permision_id", emloyee_permision_id)

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      filterFieldCompany = () => {
            const { selectedFilterEmployee, selectedFilterEntity, selectedFilterMode, requestinfos } = this.state

            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedFilterEmployee.value === 0 || temparray[i].emloyee_permision_emloyee_id === selectedFilterEmployee.value) &&
                        (selectedFilterEntity.value === 0 || temparray[i].emloyee_permision_entity === selectedFilterEntity.value) &&
                        (selectedFilterMode.value === 0 || temparray[i].emloyee_permision_mode === selectedFilterMode.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  selectedFilterEmployee,
                  optionFilterEmployee,
                  selectedFilterEntity,
                  optionFilterEntity,
                  selectedFilterMode,
                  optionFilterMode,
                  optionEmployee,
                  selectedEmployee,
                  optionEntity,
                  selectedEntity,
                  optionMode,
                  selectedMode,
                  car_priority,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPermision,
                  emloyee_permision_id,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی  دسترسی:" + emloyee_permision_id}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">کارمند </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کارمند"}
                                                                              value={selectedEmployee}
                                                                              onChange={this.handleEmployee}
                                                                              options={optionEmployee}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">مدیریت ها </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"مدیریت ها"}
                                                                              value={selectedEntity}
                                                                              onChange={this.handleEntity}
                                                                              options={optionEntity}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">عملیات ها</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"عملیات ها"}
                                                                              value={selectedMode}
                                                                              onChange={this.handleMode}
                                                                              options={optionMode}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <Grid item xs={12}>
                                                                        {newPermision ? (
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.saveNewPermision()
                                                                                    }}
                                                                              >
                                                                                    {"ثبت  دسترسی جدید "}
                                                                              </Button>
                                                                        ) : (
                                                                              <div style={{ width: "100%", textAlign: "right" }}>
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={this.newPermision}
                                                                                    >
                                                                                          {" دسترسی جدید"}
                                                                                    </Button>
                                                                                    {"          "}
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={(e) => {
                                                                                                this.deletePermision()
                                                                                          }}
                                                                                    >
                                                                                          {"حذف دسترسی "}
                                                                                    </Button>
                                                                              </div>
                                                                        )}
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نام کارمند</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نام کارمند"}
                                                                              value={selectedFilterEmployee}
                                                                              onChange={this.handleFilterEmployee}
                                                                              options={optionFilterEmployee}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">مدیریت ها</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"مدیریت ها"}
                                                                              value={selectedFilterEntity}
                                                                              onChange={this.handleFilterEntity}
                                                                              options={optionFilterEntity}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">عملیات ها </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"عملیات ها"}
                                                                              value={selectedFilterMode}
                                                                              onChange={this.handleFilterMode}
                                                                              options={optionFilterMode}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"emloyee_permision_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "emloyee_permision_id" ? order : false}
                                                                              >
                                                                                    {"آیدی  دسترسی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "emloyee_permision_id"}
                                                                                          direction={
                                                                                                orderBy === "emloyee_permision_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("emloyee_permision_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"permision_entity_desc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مدیریت ها"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "permision_entity_desc"}
                                                                                          direction={
                                                                                                orderBy === "permision_entity_desc" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("permision_entity_desc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"employee_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام کارمند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "employee_name"}
                                                                                          direction={orderBy === "employee_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("employee_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"permision_mode_desc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"عملیات ها"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "permision_mode_desc"}
                                                                                          direction={
                                                                                                orderBy === "permision_mode_desc" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("permision_mode_desc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["emloyee_permision_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"emloyee_permision_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["emloyee_permision_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"permision_entity_desc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["permision_entity_desc"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"employee_name"} align={"center"}>
                                                                                                      {row["employee_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"permision_mode_desc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["permision_mode_desc"]}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePermision)
